/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Paper } from '@material-ui/core'
import * as React from 'react'

import { escapeRoomStyles } from '../../styles/EscapeRoomStyles'
import { FileType } from '../../utils/types'
import { DescriptionTextBox } from '../atoms/DescriptionTextBox'
import { PageWrapper } from '../atoms/PageWrapper'
import { SectionTitle } from '../atoms/SectionTittle'
import { TitleInput } from '../atoms/TitleInput'
import { ImageEditor } from '../molecules/ImageEditor'

interface Props {
    title:string
    onChangeTitle(v: string): void

    description: string
    onChangeDescription(v: string): void;

    bannerImage: FileType | undefined
    onChangeBannerImage(file: FileType | undefined): void

    descriptionImage: FileType | undefined
    onChangeDescriptionImage(file: FileType | undefined): void

    onNext(): void
}

export const EditEscapeRoomStepOne: React.FC<Props> = ({
    description,
    title,
    bannerImage,
    descriptionImage,
    onChangeDescription,
    onChangeDescriptionImage,
    onChangeBannerImage,
    onChangeTitle,
    onNext
}) => {
    const eRoomStyles = escapeRoomStyles()

    const canContinue = description.length && title.length

    return (
        <PageWrapper>
            <SectionTitle text="Opret Escape Room"/>
            <div>
                <Paper
                    style={{
                        backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${bannerImage?.uri})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                    className={eRoomStyles.bannerDiv}
                    elevation={3}>
                    <ImageEditor
                        uri={bannerImage?.uri}
                        imgHeight={200}
                        imgWidth={700}
                        onChange={onChangeBannerImage}/>
                </Paper>
                <div style={{
                    display: 'flex', justifyContent: 'flex-start', width: '40%'
                }}>
                    <TitleInput
                        onChange={onChangeTitle}
                        fullWidth
                        value={title}
                        label="Tilføj en titel"/>
                </div>
            </div>

            <Paper className={eRoomStyles.directionsDiv} elevation={3}>
                <div style={{ padding: '30px 40px', display: 'flex', flexDirection: 'column' }}>
                    <DescriptionTextBox
                        label="Tilføj en beskrivelse"
                        fullWidth
                        onChange={onChangeDescription}
                        value={description}/>

                    <ImageEditor
                        uri={descriptionImage?.uri}
                        imgHeight={200}
                        imgWidth={700}
                        onChange={onChangeDescriptionImage}/>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            height: 200,
                            alignSelf: 'center',
                            width: 500,
                            marginTop: 20,
                            backgroundImage:
                                `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${descriptionImage?.uri})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }} />
                </div>
            </Paper>
            <Button
                style={{
                    backgroundColor: '#33949E',
                    color: 'white',
                    fontSize: 20,
                    minWidth: 200,
                    borderRadius: 24
                }}
                disabled={!canContinue}
                type="button"
                onClick={onNext}>
                Næste
            </Button>
        </PageWrapper>
    )
}
